import { Flex, Typography, TypographyProps } from '@aloft/toolkit-sui';

import { useFormContext } from 'react-hook-form';

import { readOnlyFieldTypographyProps } from '../../../components/PropertyGrid/fields/consts.ts';
import { getAdjustmentColor } from '../../../components/PropertyGrid/fields/utils.tsx';
import {
  PropertyGridForm,
  PropertyGridSectionProps,
} from '../../../components/PropertyGrid/types.ts';
import { selectCompAdjustments } from '../../../redux/features/selectors/adjustmentSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

const Separator = () => (
  <Flex width="100%" height="1px" gridColumn="1 / -1" backgroundColor="textPrimary" />
);

export const AdjustmentsGridAdjustedSPSection = ({
  columnIndex,
  fieldTypes,
}: PropertyGridSectionProps) => {
  const { watch } = useFormContext<PropertyGridForm>();
  const propertyId = watch(`columns.${columnIndex}.propertyId`);

  const { adjustedSalePrice, grossAdjustmentPct, netAdjustment, netAdjustmentPct } =
    useAppSelector(selectCompAdjustments)[propertyId] ?? {};

  const showLabels = fieldTypes.includes('label');

  const typographyProps: TypographyProps = {
    ...readOnlyFieldTypographyProps,
    __dangerDoNotUseSx: {
      ...readOnlyFieldTypographyProps.__dangerDoNotUseSx,
      gridColumn: showLabels ? 'span 1' : '1 / -1',
    },
  };

  return (
    <>
      <Separator />
      {showLabels && <Typography {...typographyProps}>Net Adj. Total</Typography>}
      <Typography
        {...typographyProps}
        color={getAdjustmentColor(netAdjustment?.adjustment)}
        textAlign="right"
      >
        {netAdjustment?.adjustment?.toString(true) ?? '-'}
      </Typography>
      {showLabels && <Typography {...typographyProps}>Net Adj. %</Typography>}
      <Typography {...typographyProps} textAlign="right">
        {netAdjustmentPct?.value ?? '-'}
      </Typography>
      {showLabels && <Typography {...typographyProps}>Gross Adj. %</Typography>}
      <Typography {...typographyProps} textAlign="right">
        {grossAdjustmentPct?.value ?? '-'}
      </Typography>
      <Separator />
      {showLabels && <Typography {...typographyProps}>Adjusted SP</Typography>}
      <Typography
        {...typographyProps}
        color={getAdjustmentColor(adjustedSalePrice?.adjustment)}
        textAlign="right"
      >
        {adjustedSalePrice?.value ?? '-'}
      </Typography>
    </>
  );
};
